import { createFileRoute } from "@tanstack/react-router";

import { BoardsStep } from "~/pages/onboard/steps/boards-step";

/**
 * Board picker step. Shown after the catalog step once the user proceeds.
 * The id-bearing path means the URL is shareable / refreshable without
 * losing the datasource context.
 */
export const Route = createFileRoute("/onboard/boards/$datasourceId")({
  component: () => {
    const { datasourceId } = Route.useParams();
    return <BoardsStep datasourceId={datasourceId} />;
  },
});
